import React from "react";

export default function FieldOtherRemarks({data}) {
    return <li>
        <div className="section-title">Övrig kommentar</div>
        <div className="other-comments">{data}</div>
    </li>;
}